import { combineReducers } from '@reduxjs/toolkit';
import StepwalletSlice from './StepwalletSlice';
import leaderTreeSlice from './leaderTreeSlice';


const rootReducer = combineReducers({
    Stepwallet:StepwalletSlice,
    LeaderTree: leaderTreeSlice
    
});

export default rootReducer;